import { AITrace } from "../models/aiTrace";
import axiosConfig from "./axiosConfig";

// The full AI trace, plus the short step record beside it. Two resolutions of the
// same run: `trace` is every prompt and tool result (large, for debugging), while
// `steps` is the plain-text account of what the agent did, which is what the UI
// collapses to once the live feed is gone. `steps` is null on runs from before it
// shipped.
export interface SiteHealthInvestigationTraceResponse {
  trace: AITrace | null;
  steps: string | null;
}

// Fetch the complete AI trace for one investigation run. The endpoint 404s
// when no trace exists (e.g. a run whose trace wasn't copied into a non-prod
// env), which surfaces as the query's error state - callers render that as
// "no trace available", matching getLandlordResearchTrace.
const getSiteHealthInvestigationTrace = async (
  authToken: string,
  siteId: string,
  runId: string
): Promise<SiteHealthInvestigationTraceResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/health/investigation-trace`,
    {
      params: { runId },
      headers: { Authorization: `Bearer ${authToken}` },
    }
  );
  return { trace: data?.trace ?? null, steps: data?.steps ?? null };
};

export default getSiteHealthInvestigationTrace;
